import globalLoader from './global-loader';
import updateGlobalHtmlBySettings from './update-global-html-by-settings';
import synchronizeNavigationGlobal from './synchronize-navigation-global';
import detachGlobal from './detach-global';
import resetGlobal from './reset-global';
import globalHTML from './global-html';

export default {
  globalLoader,
  updateGlobalHtmlBySettings,
  synchronizeNavigationGlobal,
  detachGlobal,
  resetGlobal,
  globalHTML,
};
